import { BlockTitle } from "@blocks/Blocks";

import ScheduleSection from "./ScheduleSection";

/**
 * Component to render time table section for FAQ Page
 */
const TimeTableSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="investor-relations-section-component"
    >
      <BlockTitle
        text="Timetable"
        rootClassName="bg-gray-150 text-2xl md:text-2xl lg:text-2xl font-semibold pb-2 pt-6 pl-4"
      />

      <ScheduleSection />
    </div>
  );
};

export default TimeTableSection;
